import { render } from "./LupaSandiPage.vue?vue&type=template&id=334f8dc3&scoped=true"
import script from "./LupaSandiPage.vue?vue&type=script&lang=js"
export * from "./LupaSandiPage.vue?vue&type=script&lang=js"

import "./LupaSandiPage.vue?vue&type=style&index=0&id=334f8dc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334f8dc3"]])

export default __exports__